<!-- Нижнее окно поверх окна блюда: выезд, свайп вниз, затемнение — SheetDirective -->
<div class="food-recomendation-container" [appSheet]="scrollRecomendationContent" (sheetClosed)="onSheetClosed()">

  <!-- Ручка: окно закрывается свайпом вниз -->
  <div class="sheet-grabber"></div>

  <div mat-icon-button (click)="close(); $event.stopPropagation()" class="close-button">
    <mat-icon class="close-icon">close</mat-icon>
  </div>

  <div class="food-recomendation-title__header">
    <p>{{ food | fieldTranslate: 'title' }}</p>
  </div>

  <div class="food-recomendation-content" #scrollRecomendationContent [class.with-order]="canOrder">

    <!-- Изображение блюда -->
    <div class="image-container">

      <img class="food-recomendation-image" mat-card-image [src]="imageSrc" [class.no-photo]="noPhoto" loading="eager" decoding="async"
        alt="Photo of the food" />
    </div>

    <!-- Наименование блюда -->
    <div class="food-recomendation-title__container" #titleRecomendationOriginal>
      <div class="food-recomendation-title">{{ food | fieldTranslate: 'title' }}</div>
    </div>

    <!-- Описание — сразу под названием: сначала о блюде, потом цифры -->
    <div class="food-recomendation-description" *ngIf="food | fieldTranslate: 'description' as description">{{ description }}</div>

    <!-- Price -->
    <div class="food-recomendation-info">
      <div class="food-recomendation-info__price" *ngIf="food.price as value">
        <ng-container *ngIf="value | priceSeparator as separated">
          <span class="food-recomendation-info__price__whole">{{ separated.whole }}</span>
          <span class="food-recomendation-info__price__dot">{{ separated.separator }}</span>
          <span class="food-recomendation-info__price__fraction">{{ separated.fraction }}</span>
          <span class="food-recomendation-info__price__currency">{{ locale?.currency }}</span>
        </ng-container>
      </div>

      <!-- Вес и время приготовления -->
      <div class="food-recomendation-info__size" *ngIf="food.size">{{ localSize }} {{ locale?.units?.get(data.unit) }}</div>
      <div class="food-recomendation-info__kkal" *ngIf="kkal">{{ roundedKkal }} {{ 'kkal' | translate }}</div>
      <div class="food-recomendation-info__time" *ngIf="data.prepare">{{ data.prepare }} {{ locale?.time }}</div>

      <!-- Энергетическая ценность — в конце строки цифр, у правого края -->
      <img *ngIf="data.kkal || data.fats || data.carbs || data.proteins"
        src="assets/info.svg"
        alt="info"
        class="food-recomendation-button"
        (click)="toggleRecomendationInfo(); $event.stopPropagation()"
      />
    </div>

    <!-- Энергетическая ценность (по кнопке информации) — в стиле таблеток аллергенов -->
    <div class="food-recomendation-info__energy-wrap" *ngIf="isInfoVisible"
     [@slideToggle]>
      <div *ngIf="data.kkal || data.fats || data.carbs || data.proteins" class="food-recomendation-info__energy">
        <div class="food-recomendation-info__energy__title">{{ 'energy' | translate }} ({{ data.energy ? '100 ' +
          (locale?.units?.get(data.unit) || 'g') : 'food' | translate }})</div>
        <div class="food-recomendation-info__energy__values">
          <div class="food-recomendation-info__energy__value" *ngIf="data.fats">{{ 'fats' | translate }}: {{ data.fats }}</div>
          <div class="food-recomendation-info__energy__value" *ngIf="data.carbs">{{ 'carbs' | translate }}: {{ data.carbs }}</div>
          <div class="food-recomendation-info__energy__value" *ngIf="data.proteins">{{ 'protein' | translate }}: {{ data.proteins }}</div>
        </div>
      </div>
    </div>

    <!-- Варианты блюда -->
    <app-menu-recomendation-food-variants *ngIf="data.variability && data.variants.length"
      [food]="data" (variantsRecomendationChange)="onVariantsRecomendationChange()">
    </app-menu-recomendation-food-variants>

    <!-- Grid модификаторов -->
    <app-menu-modificators-grid *ngIf="modificators && modificators.items.length"
        [modificators]="modificators" (modificatorsChange)="onModificatorsChange()">
    </app-menu-modificators-grid>
  </div>

  <!-- Кнопки для заказа — только со столом (без стола меню только для просмотра).
       Часть окна, а не экрана: едут вместе с ним при свайпе -->
  <div class="food-recomendation-order" *ngIf="canOrder">

    <!-- Блок управления количеством -->
    <div class="order-quantity">
      <button class="bascket-count-dec" (click)="decrement(); $event.stopPropagation()"
        [ngStyle]="{'color': food.count > 1 ? '#000000' : '#9e9e9e'}">−</button>
      <div class="order-button__count">{{ food.count }}</div>
      <button class="bascket-count-inc" (click)="increment(); $event.stopPropagation()">+</button>
    </div>

    <!-- Кнопка добавления в корзину -->
    <button class="basket-button" (click)="buttonPushRemoveFoodBasket(); $event.stopPropagation()"
      [ngStyle]="{'color': isBasket && !canUpdate ? 'red' : 'black'}" *ngIf="food.count * food.totalPrice as value">
      <span *ngIf="!isBasket">{{ 'add' | translate }}</span>
      <span *ngIf="isBasket && !canUpdate">{{ 'remove' | translate }}</span>
      <span *ngIf="isBasket && canUpdate">{{ 'update' | translate }}</span>
      <ng-container *ngIf="value | priceSeparator as separated">
        <span class="basket-button__whole">{{ separated.whole }}</span>
        <span class="basket-button__dot">{{ separated.separator }}</span>
        <span class="basket-button__fraction">{{ separated.fraction }}</span>
        <span class="basket-button__currency">{{ locale?.currency }}</span>
      </ng-container>
    </button>
  </div>
</div>
